import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  menuPopper: {
    zIndex: 1000,
  },
  handler: {
    display: 'inline-block',
  },
}));

export default useStyles;
